/**
 * メッセージ定義（正常）
 * @type     {object} 正常メッセージ
 * @property {string} I00XXX 共通機能
 * @property {string} I01XXX 企業検索
 * @property {string} I02XXX ターゲット検索
 * @property {string} I03XXX 企業情報更新
 * @property {string} I04XXX ユーザー管理
 * @property {string} I09XXX 共通メッセージ
 */
export const INFO = {
  I02001: '送信処理を開始しました。',
  I02002: '外部送信データの作成を開始しました。',
  I03001: 'バッチ処理ステータスのデータが存在しません。　({0})',
  I04001: 'パスワードを変更しますか？',
  I04002: 'パスワードを変更しました。',
  I04003: '選択したユーザーのパスワードをリセットしますか？',
  I04004: 'パスワードをリセットしました。',
  I04005: 'ユーザー情報を変更しますか？',
  I04006: 'ユーザー情報を変更しました。',
  I09001: '対象データが存在しません。',
};

/**
 * メッセージ定義（警告）
 * @type     {object} 警告メッセージ
 * @property {string} W00XXX 共通機能
 * @property {string} W01XXX 企業検索
 * @property {string} W02XXX ターゲット検索
 * @property {string} W03XXX 企業情報更新
 * @property {string} W09XXX 共通メッセージ
 */
export const WARN = {
  W02001: '※最大{0}件までしか表示されません。全ての検索結果を確認するには「ダウンロードリクエスト」を実行してください。',
  W03001: '同日のアップロードを{0}件キャンセル処理しました。',
  W03002: '処理中のアップロードが存在するため、アップロード操作はできません。',
  W03003: 'アップロード操作を行うと、{0}アップロードの{1}ファイルはキャンセルされます。',
  W03004: '過去に実施したデータ反映前のアップロード処理をキャンセルしました。',
  W09001: 'ダウンロード対象件数が{0}件以上のため処理に時間がかかります。ダウンロードしますか？',
};

/**
 * メッセージ定義（エラー）
 * @type     {object} エラーメッセージ
 * @property {string} E00XXX 共通機能
 * @property {string} E01XXX 企業検索
 * @property {string} E02XXX ターゲット検索
 * @property {string} E03XXX 企業情報更新
 * @property {string} E08XXX 入力チェック
 * @property {string} E09XXX 共通メッセージ
 */
export const ERROR = {
  E00001: 'ログインID、パスワードに誤りがあります。',
  E00002: '処理区分が更新の場合は、更新する値を1つ以上設定してください。',
  E00003: 'ダウンロードファイル作成中です。',
  E00004: 'データが取得できませんでした。',
  E00005: 'バックエンドAPIでエラーが発生しました。{0}',
  E00006: 'SFTP連携でエラーが発生しました。{0}',
  E00007: 'SFTPファイルアップロードでエラーが発生しました。{0}',
  E00008: 'SFTPファイルダウンロードでエラーが発生しました。{0}',
  E00009: 'ファイルが取得できませんでした。　({0})',
  E00010: '{0}が重複しています。{1}',
  E00011: '{0}に存在する{1}です。',
  E00012: 'バックエンドAPI接続でエラーが発生しました。{0}',
  E00013: 'バックエンドファイル連携でエラーが発生しました。{0}',
  E00014: '一定時間経過などの原因でセッションが無効となっています。再度ログインしてください。',
  E00015: '同じログインIDでのログインがあったため、セッションが無効化されました。',
  E02001: '該当条件のデータが{0}件のため、一覧表示されません。検索結果を確認するには「ダウンロードリクエスト」を実行してください。',
  E02002: '検索条件が設定されていません。検索対象以外の項目からいずれかの条件を設定してください。',
  E02003: '該当条件のデータにMFPの対象がありません。',
  E02004: '同じ条件は追加できません。',
  E02005: '追加可能上限数（100件）を超えるため、追加できません。',
  E02006: 'インポートに失敗しました。',
  E03001: 'シーケンスID不正。指定のシーケンスIDがフロントエンドDBに存在しません。　({0})',
  E03002: 'シーケンスID不正。ステータス={1}のため処理対象外です。　({0})',
  E03003: 'ファイル管理の取得に失敗しました。　({0})',
  E04001: '検索条件が設定されていません。',
  E08001: '{0}が入力されていません。',
  E08002: '{0}は{1}文字以上で入力してください。',
  E08003: '{0}は{1}文字以下で入力してください。',
  E08004: '{0}は{1}文字以上、{2}文字以下で入力してください。',
  E08005: '{0}は{1}で入力してください。',
  E08006: '{0}に存在しない{1}です。',
  E08007: '{0}のFROMに、TOを超える値が入力されています。',
  E08008: '{0}は{1}～{2}の範囲で入力してください。',
  E08009: '{0}で入力してください。',
  E08010: '{0}は{1}文字で入力してください。',
  E08011: '{0}が不正です。{2}の形式で入力してください。',
  E08012: '{0}は有効な日付ではありません。',
  E08013: '{0}はYYYY/MM/DDで入力してください。',
  E08014: 'ファイルが選択されていません。　({0})',
  E08015: 'ファイルサイズが不正です。{0}{1}以下のファイルを選択してください。　({2})',
  E08016: 'ファイル拡張子が不正です。拡張子が{0}のファイルを選択してください。　({1})',
  E08017: 'ファイル名が不正です。ファイル名が{0}文字以下のファイルを選択してください。　({1})',
  E08018: '空もしくは存在しないファイルは選択できません。　({0})',
  E08019: 'ヘッダ項目名が正しくありません。　({0})',
  E08020: 'ファイル名が不正です。同一のファイル名は選択できません。({0})',
  E08021: '一度にアップロードできるファイル件数を超過しています。{0}件以下に選択してください。',
  E08022: '{0}と{1}は違う値を入力してください。',
  E08023: '{0}と{1}は同じ値を入力してください。',
  E08024: '{0}は最低{1}以上選択してください。',
  E09001: 'ログインユーザの権限では当該画面を表示できません。',
  E09002: '{0}が取得できませんでした。　({1})',
  // 「メッセージ一覧.xlsx」では「不正なリクエストが検出されました。({0})」だが、画面上では「({0})」に代入する値がないため削除
  E09003: '不正なリクエストが検出されました。',
  E09004: 'サービス利用時間外のため、システムが利用出来ません。',
  E09005: '未認証のため、システムが利用出来ません。',
  E09006: '現在ファイル作成中のため、リクエスト実行できません。',
  E09007: '非同期ステータス管理が取得できませんでした。　({0})',
  E09008: 'ただ今サーバーが混み合っております。しばらく経ってからもう一度お試しください。',
  // ※削除のため欠番
  // E09009: '',
  E09010: 'システムエラーが発生しました。管理者へお問合せください。',
  E09011: '取得した{0}が異常です。({1})',
  E09012: 'バリデーションチェックエラーが検出されました。({0})',
  E09013: 'ネットワークエラーが発生しました。接続状況をご確認下さい。',
  E09015: 'ファイル作成でシステムエラーが発生しました。管理者へお問い合わせください。',
};
